import React, { useEffect, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Container, Button, Row } from "react-bootstrap";
import { AuthContext } from "../../App";
import Error from "../error/error";
import "./welcome.css";
import "../../components/button/button.css";
import { authentication } from "../../utils/config";
import { getUser } from "../../utils/api";
import Header from "../../components/header/header";
import ImageX from "../../assets/X.png";
const Welcome = () => {
  const lineProfile = useContext(AuthContext);
  const navigate = useNavigate();
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };
  const query = useQuery();
  useEffect(() => {
    const auth = async () => {
      const response = await authentication(lineProfile.userId);
      if (response.error || response.data === "no lineId")
        return navigate("/error");
      else if (
        response.data === "no user" ||
        response.data === "no vertification"
      )
        return navigate("/email");
      else if (response.data === "vertified") return navigate("/register");
    };
    auth();
  }, []);

  return (
    <>
      <Container
        fluid
        className="vh-100 d-flex flex-column text-center"
        style={{ backgroundColor: "#E4F4F3", minHeight: "100vh" }}
      >
        <div className="w-100 mt-3">
          <Header>
            <img
              src={ImageX}
              alt="Back"
              style={{ width: "20px", objectFit: "contain" }}
            />
          </Header>
        </div>
        <Row className="welcome-row">
          <div
            className="d-flex flex-column justify-content-center align-items-center text-center"
            style={{ height: "100%" }}
          >
            <p className="h1">
              <b>{query.get("clinicName")} 您好</b>
            </p>
            <p className="h3" style={{ color: "#42A6A1" }}>
              <b>歡迎成為元大會員!</b>
            </p>
          </div>
        </Row>
        <hr className="mx-auto my-3" />
        <Row className="d-flex flex-column justify-content-center align-items-center">
          <div className="text-center fs-5" style={{ color: "#42A6A1" }}>
            <b>是否現在登入已購入設備?</b>
          </div>
          <div className="text-center">
            <Button
              className="mt-2 w-75 btn-custom-white"
              onClick={() => {
                navigate("/handAdding");
              }}
            >
              手動輸入
            </Button>
          </div>
          <br></br>
          <div>
            <p
              className="fs-5"
              style={{ color: "#999C9C" }}
              onClick={() => {
                navigate("/missing");
              }}
            >
              <u>
                <b>機器號碼遺失?</b>
              </u>
            </p>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default Welcome;
